export enum Stroke {
  bold = 'bold',
  normal = 'normal',
  thin = 'thin'
}
